import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CommonDataService } from '../services/common-data.service';
import { first } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Accept': 'application/json',
  }),
  withCredentials: false
};

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  authDetailsChanged = new Subject<any>();
  subscription:any;
  authDetails;

  constructor(public http: HttpClient, private _data: CommonDataService) { 

    //lets create a subscription of 
    this.subscription = this.authDetailsChanged.subscribe(
      (data) => {
        this.authDetails = data;
      }
    );
  }


  public login(userName: string, password: string)  {
    
    return this.http.post<any>(`${environment.apiUrl}/api-login`, { userName: userName, password: password }, httpOptions);
    
  }

  public requestPasswordReset(userName: string) {

  	var endpoint = 'forgot-password';
    return this.dataRequest({ userName: userName }, endpoint);
  }

  public registerUser(data: any) {

  	var endpoint = 'api-register-user';
    return this.dataRequest( data, endpoint);

  }

  public isUserLoggedIn() : boolean {

    if (localStorage.getItem("authkey") === null && localStorage.getItem("apikey") === null) {
      //...
      return false;
    }

    return true;
  }

  public logout() {
  	localStorage.removeItem('authkey');
    localStorage.removeItem('apikey');
    localStorage.removeItem('selectedAddress');
    
    sessionStorage.removeItem('created');
    sessionStorage.removeItem('BNFGSHGFGG');
    sessionStorage.removeItem('context');
    sessionStorage.removeItem('contextData');
    sessionStorage.removeItem('yheyhhshshveri');
  }

  public getAuthKey() {
  	return localStorage.getItem("authkey");
  }

  public getApiKey() {
  	return localStorage.getItem("apikey");
  }

  public saveSessionDetails(dataObject: any, objectName : any){
    // Create item:
    sessionStorage.setItem(objectName, JSON.stringify(dataObject));
  }

  public getSessionDetails(objectName : any){
    return JSON.parse(sessionStorage.getItem(objectName));
  }

  dataRequest(data: any, endpoint: string) {
    return this.http.post(`${environment.apiUrl}/` , data);
  }

}
